declare module '@angular/core' {
  interface ModuleWithProviders<T = any> {
    ngModule: Type<T>;
  }
}

import { BrowserModule } from '@angular/platform-browser';
import { Injectable, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';

// import {
//   SocialLoginModule,
//   GoogleLoginProvider,
//   SocialAuthServiceConfig
// } from '@abacritt/angularx-social-login';
// import { NgxPaginationModule } from 'ngx-pagination';
import { HomePageComponent } from './views/home-page/home-page.component';
import { UserHomeComponent } from './views/user-home/user-home.component';
import { UsersPageComponent } from './views/users-page/users-page.component';
import { SharedUIModuleModule } from './shared/shared-uimodule/shared-uimodule.module';

import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CustomersPageComponent } from './views/customers-page/customers-page.component';
import { AppointmentCreatorComponent } from './components/appointment-creator/appointment-creator.component';
import { CalendarPageComponent } from './views/calendar-page/calendar-page.component';
import { CreateCustomerComponent } from './components/create-customer/create-customer.component';
import { CustomerPickerComponent } from './components/customer-picker/customer-picker.component';
import { HorsePickerComponent } from './components/horse-picker/horse-picker.component';
import { CreateHorseComponent } from './components/create-horse/create-horse.component';
import { AddressPickerComponent } from './components/address-picker/address-picker.component';
import { AddressCreatorComponent } from './components/address-creator/address-creator.component';
import { AppointmentDetailsComponent } from './components/appointment-details/appointment-details.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { MatMenuModule } from '@angular/material/menu';
import { MatStepperModule } from '@angular/material/stepper';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatRadioModule } from '@angular/material/radio';

// import { CalendarViewComponent } from './components/calendar-view/calendar-view.component';
// import { MonthDayComponent } from './components/CalendarElements/month-day/month-day.component';
// import { WeekDayComponent } from './components/CalendarElements/week-day/week-day.component';
// import { DayComponent } from './components/CalendarElements/day/day.component';
// import { DragDropModule } from '@angular/cdk/drag-drop';
// import { WeekDayHeaderComponent } from './components/CalendarElements/week-day-header/week-day-header.component';
// import { SideBarMonthDayComponent } from './components/CalendarElements/side-bar-month-day/side-bar-month-day.component';

import { FullCalendarModule } from '@fullcalendar/angular'; // for FullCalendar!

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AppointmentPageComponent } from './views/appointment-page/appointment-page.component';

import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { CustomerDetailsPageComponent } from './views/customer-details-page/customer-details-page.component';
import { DetailsTableFormComponent } from './components/details-table-form/details-table-form.component';
import { HorseDetailsPageComponent } from './views/horse-details-page/horse-details-page.component';
import { HorsesTableComponent } from './components/horses-table/horses-table.component';
// import { AppointmentSummaryComponent } from './components/appointment-summary/appointment-summary.component';
import { NewBookingInfoComponent } from './views/new-booking-info/new-booking-info.component';
import { PublicHeaderComponent } from './components/public-header/public-header.component';
import { VerifyCodeComponent } from './components/verify-code/verify-code.component';
import { FormSectionEnabledPipe } from './pipes/form-sectoin.pipe';
import { CardPaymentComponent } from './components/card-payment/card-payment.component';
import { ProvisionalBookingComponent } from './components/provisional-booking/provisional-booking.component';

// import { AngularFireModule } from '@angular/fire/compat';
// import { AngularFireAuthModule, USE_DEVICE_LANGUAGE, USE_EMULATOR as USE_AUTH_EMULATOR } from '@angular/fire/compat/auth';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { environment } from '../environments/environment';
import { MyAccountComponent } from './views/my-account/my-account.component';
import { CustomerLoginComponent } from './views/customer-login/customer-login.component';
import { SettingsComponent } from './views/settings/settings.component';

import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { AppointmentEditSlideoverComponent } from './views/appointment-edit-slideover/appointment-edit-slideover.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { AddressFormatterPipe } from './address-formatter.pipe';
import { CustomerEditFormComponent } from './components/customer-edit-form/customer-edit-form.component';
import { ModalComponent } from './components/modal/modal.component';
import { AppointmentRatingComponent } from './components/appointment-rating/appointment-rating.component';

import { NgIconsModule } from '@ng-icons/core';
import {  heroStar } from '@ng-icons/heroicons/outline';
import {  heroStarSolid } from '@ng-icons/heroicons/solid';

// const config = new AuthServiceConfig([
//   {
//     id: GoogleLoginProvider.PROVIDER_ID,
//     provider: new GoogleLoginProvider('269853954757-6he76vnf98igaarhndaeqfiin692n45r.apps.googleusercontent.com')
//   }
// ]);

// export function getAuthServiceConfigs() {
//   let config = new AuthServiceConfig(
//       [
//         {
//           id: GoogleLoginProvider.PROVIDER_ID,
//           provider: new GoogleLoginProvider('269853954757-6he76vnf98igaarhndaeqfiin692n45r.apps.googleusercontent.com')
//         }
//       ]
//   );
//   return config;
// }

// const socialLoginproviders = {
//   provide: 'SocialAuthServiceConfig',
//   useValue: {
//     autoLogin: false,
//     lang: 'en',
//     providers: [
//       {
//         id: GoogleLoginProvider.PROVIDER_ID,
//         provider: new GoogleLoginProvider(
//           '269853954757-6he76vnf98igaarhndaeqfiin692n45r.apps.googleusercontent.com'
//         )
//       }
//     ],
//     onError: (err) => {
//       console.error(err);
//     }
//   } as SocialAuthServiceConfig,
// }



@NgModule({
  declarations: [
    AppComponent,
    HomePageComponent,
    UserHomeComponent,
    UsersPageComponent,
    CustomersPageComponent,
    AppointmentCreatorComponent,
    CalendarPageComponent,
    CreateCustomerComponent,
    CustomerPickerComponent,
    HorsePickerComponent,
    CreateHorseComponent,
    AddressPickerComponent,
    AddressCreatorComponent,
    AppointmentDetailsComponent,
    // CalendarViewComponent,
    // MonthDayComponent,
    // WeekDayComponent,
    // WeekDayHeaderComponent,
    // DayComponent,
    // WeekDayHeaderComponent,
    // SideBarMonthDayComponent,
    AppointmentPageComponent,
    CustomerDetailsPageComponent,
    DetailsTableFormComponent,
    HorseDetailsPageComponent,
    HorsesTableComponent,
    // AppointmentSummaryComponent,
    NewBookingInfoComponent,
    PublicHeaderComponent,
    VerifyCodeComponent,
    FormSectionEnabledPipe,
    CardPaymentComponent,
    ProvisionalBookingComponent,
    MyAccountComponent,
    CustomerLoginComponent,
    SettingsComponent
    
    
  ],
  bootstrap: [AppComponent],
  exports: [
    MatMenuModule,
    // MonthDayComponent,
    // WeekDayComponent,
    // DayComponent,
    // WeekDayHeaderComponent,
    FontAwesomeModule
  ], imports: [
    
    BrowserModule,
    NgIconsModule.withIcons({ heroStarSolid, heroStar }),
    AppRoutingModule,
    SharedUIModuleModule,
    ReactiveFormsModule,
    // NgxPaginationModule,
    FormsModule,
    BrowserAnimationsModule,
    MatMenuModule,
    MatStepperModule,
    MatFormFieldModule,
    MatCardModule,
    MatGridListModule,
    MatButtonModule,
    MatInputModule,
    MatListModule,
    MatIconModule,
    MatExpansionModule,
    MatAutocompleteModule,
    MatSidenavModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    MatSelectModule,
    MatChipsModule,
    MatTableModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatTabsModule,
    MatRadioModule,
    // DragDropModule,
    FullCalendarModule,
    FontAwesomeModule,
    AngularFireModule.initializeApp(environment.firebase),
    AppointmentEditSlideoverComponent,
    SpinnerComponent,
    ModalComponent,
   
    

    
  ],
  providers: [
    //socialLoginproviders,
    CookieService,
    AngularFireAuthModule,
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideHttpClient(withInterceptorsFromDi()),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),
    
  ]
})
export class AppModule {
}
